import React from "react";
import { Link, useParams } from "react-router-dom";
import { Clock, ArrowLeft, ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { getBlogPost } from "@/lib/blogContent";

const BlogPost = () => {
  const { slug } = useParams();
  const { language, t } = useLanguage();
  const post = getBlogPost(language, slug);

  return (
    <div className="bg-white" data-testid="blog-post-page">
      <section className="pt-24 pb-12 lg:pt-32 lg:pb-16">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Link
            to="/blog"
            className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-teal-700"
            data-testid="back-to-blog"
          >
            <ArrowLeft size={14} /> {t("blogPost.backToBlog")}
          </Link>

          {!post && (
            <div className="mt-12 text-slate-700">
              {t("blogPost.notFound")}{" "}
              <Link to="/blog" className="text-teal-700 underline">{t("blogPost.allArticles")}</Link>
            </div>
          )}

          {post && (
            <article>
              <div className="mt-8 inline-flex items-center px-2.5 py-1 rounded-full bg-teal-50 text-teal-800 text-[11px] uppercase tracking-[0.14em] border border-teal-100">
                {post.category}
              </div>
              <h1 className="mt-5 font-display text-4xl lg:text-5xl text-slate-900 leading-tight tracking-tight">
                {post.title}
              </h1>
              <div className="mt-4 flex items-center gap-3 text-sm text-slate-500">
                <span>{post.published_at}</span>
                <span>·</span>
                <span className="inline-flex items-center gap-1">
                  <Clock size={13} /> {post.read_minutes} {t("blogPost.minutes")}
                </span>
                <span>·</span>
                <span>{post.author}</span>
              </div>

              <img
                src={post.cover_image}
                alt={post.title}
                className="mt-10 w-full rounded-2xl object-cover aspect-[16/9]"
                data-testid="blog-cover-image"
              />

              <div className="mt-10 prose prose-slate max-w-none">
                {post.content.split("\n\n").map((para, i) => (
                  <p key={i} className="text-slate-700 leading-[1.85] whitespace-pre-wrap mb-5">
                    {para}
                  </p>
                ))}
              </div>

              <div className="mt-14 pt-10 border-t border-slate-200 flex items-center justify-between">
                <Link
                  to="/blog"
                  className="inline-flex items-center gap-1.5 text-sm text-slate-700 hover:text-teal-700"
                  data-testid="post-back-link"
                >
                  <ArrowLeft size={14} /> {t("blogPost.otherArticles")}
                </Link>
                <Link
                  to="/iletisim"
                  className="inline-flex items-center gap-2 px-5 h-11 rounded-full bg-teal-700 text-white text-sm font-medium hover:bg-teal-800 transition-colors"
                  data-testid="post-cta-contact"
                >
                  {t("blogPost.ctaConsult")} <ArrowRight size={14} />
                </Link>
              </div>
            </article>
          )}
        </div>
      </section>
    </div>
  );
};

export default BlogPost;
